import React, { useEffect, useState } from "react";
import "./ErpN.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import erp1 from "../../assets/Book_Demo.png";
import Erp_clients from "./Erp_clients.js";
import erp_devicecompactability from "../../assets/erp_mobileimg.jpg";
import erp_tabcompactability from "../../assets/erp-tabremovebg-preview.png";
import erp_desktop from "../../assets/erp-deskimg.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import AdhikritErpInterface from "./AdhikritErpInterface.js";
import rating_image from "../../assets/rating1_image.png";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Tooltip } from "@mui/material";
import styled from "styled-components";

const ErpN = () => {
  const typingSpeed = 90;
  const pauseBetweenTexts = 1000;
  const [isTyping, setIsTyping] = useState(true);
  const [displayedText, setDisplayedText] = useState("");
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  const texts = [
    "Productive",
    "Empowered",
    "Streamlined",
    "Transformative",
    "Proficient",
    "Flexible",
  ];

  

  const StyledWrapper = styled.div`
    button {
      height: 3em;
      width: 8em;
      border: none;
      border-radius: 10em;
      background: orange;
      font-size: 17px;
      color: #000;
      font-family: inherit;
      font-weight: 800;
    }

    button:hover {
      animation: shake3856 0.3s linear infinite both;
    }

    @keyframes shake3856 {
      0% {
        -webkit-transform: translate(0);
        transform: translate(0);
      }

      20% {
        -webkit-transform: translate(-2px, 2px);
        transform: translate(-2px, 2px);
      }

      40% {
        -webkit-transform: translate(-2px, -2px);
        transform: translate(-2px, -2px);
      }

      60% {
        -webkit-transform: translate(2px, 2px);
        transform: translate(2px, 2px);
      }

      80% {
        -webkit-transform: translate(2px, -2px);
        transform: translate(2px, -2px);
      }

      100% {
        -webkit-transform: translate(0);
        transform: translate(0);
      }
    }
  `;

  useEffect(() => {
    let timeout;

    if (isTyping) {
      if (displayedText.length < texts[currentTextIndex].length) {
        timeout = setTimeout(() => {
          setDisplayedText(
            (prev) =>
              prev + texts[currentTextIndex].charAt(displayedText.length)
          );
        }, typingSpeed);
      } else {
        timeout = setTimeout(() => setIsTyping(false), pauseBetweenTexts);
      }
    } else {
      if (displayedText.length > 0) {
        timeout = setTimeout(() => {
          setDisplayedText((prev) => prev.slice(0, -1));
        }, typingSpeed);
      } else {
        setIsTyping(true);
        setCurrentTextIndex((prev) => (prev + 1) % texts.length);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayedText, isTyping, texts, currentTextIndex]);

  const Highlight = [
    {
      content: "Simplified User Interface",
    },
    {
      content: "Extensively Configurable",
    },
    {
      content: "Cross-Platform Accessibility (Web & Mobile & Tablet)",
    },
    {
      content: "Advanced Security Standards",
    },
  ];

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fieldsetStyles = {
    border: "2px solid #FF9800",
    padding: screenWidth > 768 ? "20px" : "15px",
    borderRadius: "15px",
    position: "relative",
    margin: screenWidth > 768 ? "40px" : "30px",
  };

  const legendStyles = {
    fontWeight: "bold",
    padding: "0 10px",
    backgroundColor: "#fff",
    position: "absolute",
    top: screenWidth > 768 ? "-15px" : "-18px",
    left: screenWidth > 768 ? "10px" : "5px",
    fontSize: screenWidth > 768 ? "16px" : "14px",
  };


  const [activeSlide, setActiveSlide] = useState(0);

  const legends = [
    "HOD",
    "Admin",
    "Faculty",
    "Student",
    "Accounts",
    "Library",
    "Transport",
    "Leave-Management",
    "Hostel",
    "Greivance",
    "Placement",
    "Payroll",
    "Chairman",
    "Parent",
  ];

  const slideData = [
    {
      id: 1,
      content: [
        "Streamlines course management, enabling better organization and efficiency.",
        "Facilitates student performance tracking for monitoring progress and identifying issues.",
        "Ensures effective attendance monitoring with automated tracking features.",
        "Oversees assignment submissions, evaluation, and feedback processes.",
        "Provides efficient access to departmental resources and learning materials.",
      ],
    },
    {
      id: 2,
      content: [
        "Comprehensive institution updates for streamlined communication.",
        "Centralized management of employee details and information.",
        "Access to financial insights for informed decision-making.",
        "Efficient task assignments with clearly defined deadlines.",
        "Progress tracking through a unified and user-friendly interface.",
      ],
    },
    {
      id: 3,
      content: [
        "Efficient course management for organizing and maintaining course materials.",
        "Tools for tracking and evaluating student performance.",
        "Attendance tracking to monitor student participation effectively.",
        "Oversight of assignments, including submissions and progress monitoring.",
        "Easy access to resources for both students and faculty.",
      ],
    },
    {
      id: 4,
      content: [
        "Seamless access to course materials, grades, and progress tracking.",
        "Efficient management of assignments and exams.",
        "Generation and access to detailed academic performance reports.",
        "Easy access to essential resources for academic success.",
        "Organized class and exam timetables for better scheduling.",
      ],
    },
    {
      id: 5,
      content: [
        "Provides streamlined access to financial records and transactions.",
        "Facilitates budget tracking with real-time updates.",
        "Simplifies financial operations for efficiency and accuracy.",
        "Ensures effective and reliable account management.",
        "Revolutionize your institution with our cutting-edge ERP suite.",
      ],
    },
    {
      id: 6,
      content: [
        "Provides seamless access to book catalogs for quick searches and reservations.",
        "Enables efficient loan tracking to manage borrowed and returned books.",
        "Simplifies inventory management for accurate library resource tracking.",
        "Enhances library operations with automation, reducing manual tasks.",
        "Ensures organized and efficient access to both physical and digital resources.",
      ],
    },
    {
      id: 7,
      content: [
        "Offers efficient access to route planning for optimized travel paths.",
        "Provides real-time vehicle tracking for better monitoring and safety.",
        "Simplifies schedule management for timely transportation services.",
        "Enhances transportation logistics with streamlined operations.",
        "Reduces operational delays with effective planning and execution.",
      ],
    },
    {
      id: 8,
      content: [
        "Provides an intuitive interface for easy submission of leave requests.",
        "Enables real-time tracking of leave application statuses.",
        "Simplifies leave approvals for managers with automated workflows.",
        "Ensures efficient leave management for both employees and managers.",
        "Improves employee experience with a user-friendly leave tracking system.",
      ],
    },
  ];

  const buttons = [
    {
      label: "",
      tooltip:
        "Manage financial transactions, reports, and budgets effectively.",
    },
    {
      label: "",
      tooltip: "Track book inventory, borrowing, and returns seamlessly.",
    },
    {
      label: "",
      tooltip: "Organize and monitor transportation schedules and routes.",
    },
    {
      label: "",
      tooltip:
        "Streamline leave requests and approvals for staff and students.",
    },
    {
      label: "",
      tooltip: "Efficiently manage hostel accommodations and records.",
    },
    {
      label: "",
      tooltip:
        "Resolve complaints with a transparent grievance redressal system.",
    },
    {
      label: "",
      tooltip: "Track and manage student placements and employer engagements.",
    },
    {
      label: "",
      tooltip: "Simplify payroll processing and salary disbursement.",
    },
    {
      label: "",
      tooltip: "Access high-level insights and institute-wide reports.",
    },
    {
      label: "",
      tooltip: "Monitor your child's academic progress and activities.",
    },
    {
      label: "",
      tooltip: "Department-specific insights for Heads of Departments.",
    },
    {
      label: "",
      tooltip: "Comprehensive tools for administration and management.",
    },
    {
      label: "",
      tooltip: "Teaching resources and tools for efficient course delivery.",
    },
    {
      label: "",
      tooltip: "Access study materials, grades, and academic updates.",
    },
  ];

  const radius = 300;

  return (
    <div className="Aspiron_container">
      <div className="adaptive-erp-container">
        <div className="erp-content">
          <h1 className="erp-title">
            Adaptive ERP Solution with <br /> Low-Code Agility <br />
            <span className="erp-animated-text">{displayedText}</span>
          </h1>
          <p className="erp-description">
            Design, oversee, streamline, and connect tailored ERP systems that
            align seamlessly with your organization's distinct workflows—all
            while maintaining budget transparency and avoiding hidden fees.
          </p>
          <a
            href="https://calendly.com/aspiron-technologies1/30min"
            target="_blank"
            rel="noopener noreferrer"
          >
            <StyledWrapper>
              <button> Get Demo</button>
            </StyledWrapper>
          </a>
          <div className="highlight-list">
            {Highlight.map((item, index) => (
              <div key={index} className="highlight-item">
                <CheckCircleIcon sx={{ color: "green" }} />
                &nbsp;<span>{item.content}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="erp-image-container">
          <img className="erp-floating-image" src={erp1} alt="ERP Solution" />
        </div>
      </div>
      <br />
      <br />
      <h1 className="erp-title2">
        Adhikrit ERP: Bridging Excellence and Efficiency for Institutions.
      </h1>
      <div className="circlectn-container">
        <div className="circlectn-content">
          <div className="circlectn-left">
            <div className="circle-container">
              {buttons.map((button, index) => {
                const angle = (index / buttons.length) * 360;
                const x = radius * Math.cos((angle * Math.PI) / 180);
                const y = radius * Math.sin((angle * Math.PI) / 180);

                const placement =
                  angle > 45 && angle <= 135
                    ? "bottom"
                    : angle > 135 && angle <= 225
                    ? "left"
                    : angle > 225 && angle <= 315
                    ? "top"
                    : "right";

                return (
                  <Tooltip
                    sx={{
                      "& .MuiTooltip-tooltip": {
                        backgroundColor: "red", // Tooltip background color
                        color: "#fff", // Text color
                        fontSize: "14px", // Text size
                      },
                      "& .MuiTooltip-arrow": {
                        color: "#3498db", // Arrow color
                      },
                    }}
                    placement={placement}
                    key={index}
                    title={
                      <div
                        style={{
                          borderRadius: "20px",
                          textAlign: "center",
                          fontSize: "14px",
                          lineHeight: "1.5",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            width: "200px",
                          }}
                        >
                          {button.tooltip}
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            bottom: "-8px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: "10px",
                            height: "10px",
                            clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
                          }}
                        ></div>
                      </div>
                    }
                  >
                    <button
                      className="circle-button"
                      style={{
                        transform: `translate(${x}px, ${y}px)`,
                        border: "none",
                        cursor: "pointer",
                        fontSize: "12px",
                      }}
                    >
                      {button.label}
                    </button>
                  </Tooltip>
                );
              })}
            </div>
          </div>
          <div className="circle-right">
            <form>
              <fieldset className="circle-fieldset">
                <legend className="circle-legend">
                  {legends[activeSlide]}
                </legend>
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  pagination={{ clickable: true }}
                  autoplay={{ delay: 5000 }}
                  spaceBetween={20}
                  slidesPerView={1}
                  loop={true}
                  onSlideChange={(swiper) => setActiveSlide(swiper.realIndex)}
                >
                  {slideData.map((slide, index) => (
                    <SwiperSlide key={slide.id}>
                      <div className="text_class">
                        {slide.content.map((text, index) => (
                          <div key={index} style={{ display: "flex" }}>
                            <TaskAltIcon style={{ color: "green" }} />
                            <p className="text_para">{text}</p>
                          </div>
                        ))}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
      <form>
        <fieldset
          className="fieldset_deviceCompactability"
          style={fieldsetStyles}
        >
          <legend className="txt_deviceCompactability" style={legendStyles}>
            Device Compatibility
          </legend>

          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            spaceBetween={20}
            slidesPerView={1}
            loop={true}

            // style={{ marginTop: "10px" }}
          >
            <SwiperSlide>
              <div className="main_deviceCompactability">
                <img
                  className="deviceCompactability"
                  src={erp_desktop}
                  alt="Desktop Compatibility"
                />
                <p className="text_MobileCompactability">
                  "Adhikrit ERP on Desktop: Work Smarter, Not Harder" Experience
                  seamless multitasking and in-depth functionality with Adhikrit
                  ERP’s desktop version. Designed for detailed operations and
                  full-fledged business management.
                </p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="main_deviceCompactability">
                <img
                  className="deviceCompactability"
                  src={erp_devicecompactability}
                  alt="Mobile Compatibility"
                />
                <p className="text_MobileCompactability">
                  "Adhikrit ERP on Mobile: Power in Your Pocket" Adhikrit ERP’s
                  mobile compatibility lets you run your business like a pro on
                  the go. From quick analytics to instant updates, it’s your
                  business in your palm.
                </p>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="main_deviceCompactability">
                <img
                  className="deviceCompactability"
                  src={erp_tabcompactability}
                  alt="Tablet Compatibility"
                />
                <p className="text_MobileCompactability">
                  "Adhikrit ERP on Tablet: Your Bridge Between Mobility and
                  Productivity" The perfect balance of portability and
                  power—Adhikrit ERP on tablets offers intuitive interfaces for
                  business tasks, even during travel or meetings.
                </p>
              </div>
            </SwiperSlide>
          </Swiper>
        </fieldset>
      </form>
      <div>
        <Erp_clients />
      </div>
      <div>
        <AdhikritErpInterface />
      </div>

      <div className="image_container">
        <img className="rating_image" src={rating_image} alt="img"></img>
        {/* <StyledWrapper>
      <div className="rating">
        <input defaultValue={5} name="rate" id="star5" type="radio" />
        <label title="text" htmlFor="star5" />
        <input defaultValue={4} name="rate" id="star4" type="radio" defaultChecked/>
        <label title="text" htmlFor="star4" />
        <input defaultValue={3} name="rate" id="star3" type="radio"  />
        <label title="text" htmlFor="star3" />
        <input defaultValue={2} name="rate" id="star2" type="radio" />
        <label title="text" htmlFor="star2" />
        <input defaultValue={1} name="rate" id="star1" type="radio" />
        <label title="text" htmlFor="star1" />
      </div>
    </StyledWrapper> */}
        <span className="rating_text">
          4.5/5 Trusted Reviews for Adhikrit ERP
        </span>
        <div></div>
      </div>
    </div>
  );
};

export default ErpN;
